
<template lang="html">

  <div class="project-container">

  
  <div v-if="project.type === 'v'">
    <section class="double-top-pad">
      <div class="top-block"></div>
      <div class="video-inset-container">
        <iframe :src="videourl" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
      </div>

      <div class="container project-label-container">
        <div class="row">
          <div class="col-12">
            <label>{{ project.subtitle }}</label>
          </div>
        </div>
      </div>

      <div v-if="project.images.length > 0" class="video-project-gallery">

      <my-carousel
        :array="project.images"
      ></my-carousel>  

      <div v-if="project.video_boxes != null">
        <video-boxes
          :videos="project.video_boxes"
        >
        </video-boxes>
      </div>
      

    </div>

      <div class="text-center project-label-container">
  
            <router-link :to="'/'">
              <div class="block-button back-button mybutton-back-smallmargin">
                <div class="mybutton-up">BACK</div>
                <div class="mybutton-down">BACK</div>
              </div>
            </router-link>
      
      </div>
    </section>
  </div>


  <div v-if="project.type === 'i'">
    <section class="double-top-pad">
      <div class="top-block"></div>

      <my-carousel
        :array="project.images"
        :hasVideoBoxes="project.video_boxes"
      ></my-carousel>    

      <div v-if="project.video_boxes != null">
        <video-boxes
          :videos="project.video_boxes"
        >
        </video-boxes>
      </div>

      <div class="container project-label-container">
        <div class="row">
          <div class="col-12">
            <router-link :to="'/'">
              <div class="block-button back-button mybutton-back-smallmargin">
                <div class="mybutton-up">BACK</div>
                <div class="mybutton-down">BACK</div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>     
  </div>

      <section class="name-section name-section-small">
      <div class="name-section-inner name-section-inner-black"></div>
    </section>
    
  </div>
</template>

<style type="text/css">

.project-label-container {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
}
.project-label-container label {
  font-size: 16px;
  margin: 0;
}



</style>

<script>
import {projects} from '../../content.json'
// var dataURL = 'https://api.ralphandco.com/updates'
import {commontools} from '../mixins/Styling'
import MyCarousel from '../components/MyCarousel.vue'
import VideoBoxes from '../components/VideoBoxes.vue'
import Vue from 'vue'

export default {
  mixins: [commontools],
  name: 'projects',
  data () {
    return {
      projects,
      pagename: null,
      project: {},
      contentReady: false,
      loadCounter: 0,
      hasGallery: true,
      counter: 0,
      videourl: null
    }
  },
  methods: {
    getNavParams () {
      this.projects.map((p) => {
        if (p.url === this.$route.params.id) {
          this.project = p;
          if (this.project.type === 'v') this.setVideoUrl()
          this.contentReady = true
        }
      })
    },
    setVideoUrl: function () {
      this.videourl = 'https://player.vimeo.com/video/' + this.project.video_id + '?background=0&autoplay=1&muted=0&loop=0&byline=0&title=0'
    },
    getImages () {
      if (this.project.images.length <= 1) {
        this.hasGallery = false
        return
      }

      this.loadCounter = this.project.images.length

      let total = 0

      this.project.images.map(image => {
        this.preloadImages('static/img/content/'+image.img).then(myimg => {
          let ar = myimg.naturalWidth / myimg.naturalHeight
          Vue.set(image, 'ar', ar)
          Vue.set(image, 'x', total)
          total += Math.floor((window.innerHeight * 0.8) * ar)
          this.loadCounter--
          if (this.loadCounter === 0) this.isReady = true
        })
      })
    },
    clickCarousel () {

      this.project.images.map((image) => {
        image.x -= (this.project.images[this.counter].ar * Math.floor(window.innerHeight * 0.8))
        console.log(image.x)
      })

      this.counter++
      if (this.counter >= this.project.images.length) {
        this.counter = 0
      }
    }
  },
  created: function () {
    window.scrollTo(0, 0)
  },
  mounted: function () {
    this.getNavParams()
    // setTimeout(() => {
    //   this.manageWidows()
    // }, 100)
  },
  components: {
    MyCarousel,
    VideoBoxes
  }
}
</script>